import Store from '@app/store';
import Actions from '@app/action';
import Cookie from '@wetransfer/concorde-cookie';
import BrowserStorage from '@module/browserstorage';

const cotrackerName = '_wt_snowplow';
const moveCookieToLocalstore = () => {
  // https://webkit.org/blog/8613/intelligent-tracking-prevention-2-1/
  // Under ITP2.1 analytic cookie will be expired after 7 days,
  // in that case we can't track user interaction when they return after 7 days.

  // To bypass that policy we store tracking information from cookie to localStorage.

  // However snowplow tracker generates new user id without checking the cookie first.
  // So here's a patch for copying snowplow cookie to localStore before initalize the tracker

  if (!BrowserStorage.isSupported) return; // IOS Safari private mode

  let suffix = 'a4e2';
  if (window.__snowplow__ && window.__snowplow__.namespace) {
    suffix = window.__snowplow__.namespace;
  }

  const coTracker = Cookie.get(`${cotrackerName}id.${suffix}`);
  const adImpressionTracker = Cookie.get(`_sp_id.${suffix}`);

  if (coTracker) {
    BrowserStorage.setItem(`${cotrackerName}id.${suffix}`, coTracker);
    BrowserStorage.setItem(`${cotrackerName}ses.${suffix}`, '*');
  }
  if (adImpressionTracker) {
    BrowserStorage.setItem(`_sp_id.${suffix}`, adImpressionTracker);
    BrowserStorage.setItem(`_sp_ses.${suffix}`, '*');
  }
};

export const snowplowInit = () => {
  if (!window.__snowplow__) {
    return;
  }

  moveCookieToLocalstore();
  const baseConfig = {
    bufferSize: 1,
    post: true,
    encodeBase64: false,
    respectDoNotTrack: true,
    userFingerprint: false,
    appId: 'transfer_core',
    platform: 'web',
    stateStorageStrategy: 'localStorage',
  };
  window.__snowplow__('newTracker', 'co', window.__snowplow__.collector, {
    ...baseConfig,
    contexts: {
      webPage: true,
    },
    cookieName: cotrackerName,
    discoverRootDomain: true,
  });

  window.__snowplow__(
    'newTracker',
    'ad_impressions',
    window.__snowplow__.collector,
    baseConfig
  );

  if (
    window.__session__ &&
    window.__session__.user &&
    window.__session__.user.id
  ) {
    window.__snowplow__('setUserId', window.__session__.user.id);
  }

  window.__snowplow__('enableLinkClickTracking:co');
  window.__snowplow__('enableActivityTracking:co', 10, 15); // 10s before the first ping, then an interval of 15s

  try {
    window.__snowplow__(function() {
      Store.dispatch(
        Actions.Session.setDomainUserId(this.co.getDomainUserInfo()[1])
      );
    });
  } catch (e) {
    /* do nothing */
  }
};

snowplowInit();
